import { clock } from '#apps/client-web/app/services/clock';
import { deepFreeze } from '#packages/data-collection/utils/object';

import { AppConfigSchema } from './app';

export const appConfig = deepFreeze(
  AppConfigSchema.parse({
    isLocal: import.meta.env.APP_CLIENT_WEB_IS_LOCAL,

    version: import.meta.env.APP_CLIENT_WEB_VERSION,
    buildTimestamp:
      import.meta.env.APP_CLIENT_WEB_BUILD_TIMESTAMP ?? clock.now().toString(),
  }),
);

export const useAppConfig = () => appConfig;
